const config = {
  API_BASE_URL: 'https://api.timelyhealth.in/api'
};

export default config;
